import { cn } from "@/lib/utils";

export function SectionHeader({
    title,
    meta,
    action,
    className,
}: {
    title: string;
    meta?: string;
    action?: React.ReactNode;
    className?: string;
}) {
    return (
        <div className={cn("flex items-end justify-between gap-3", className)}>
            <div>
                <div className="text-[10px] font-black uppercase tracking-widest text-text-muted">
                    {meta ?? "SECTION"}
                </div>
                <div className="text-white font-extrabold tracking-tight text-lg">
                    {title}
                </div>
            </div>
            {action ? <div className="shrink-0">{action}</div> : null}
        </div>
    );
}
